const DISABLED = 'is-scrolling-disabled';

let offset = 0;

export function getScrollTop() {
    return document.body.scrollTop || document.documentElement.scrollTop;
}

export function getScrollHeight() {
    return document.body.scrollHeight || document.documentElement.scrollHeight;
}

export function getScrollLeft() {
    return document.body.scrollLeft || document.documentElement.scrollLeft || 0;
}

export function disableScrolling() {
    offset = getScrollTop();
    document.body.style.top = `${-offset}px`;
    document.documentElement.classList.add(DISABLED);
}

export function getScroll() {
    return {
        x: getScrollLeft(),
        y: getScrollTop()
    }
}
export function enableScrolling() {
    document.body.removeAttribute('style');
    document.documentElement.classList.remove(DISABLED);
    document.body.offsetWidth;
    window.scrollTo(0, offset);
}
